import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MenuInfo } from '@models/genel/MenuInfo';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  public configModel: any = {};
  public onMenuUpdated$: BehaviorSubject<any> = new BehaviorSubject(
    this.configModel
  );

  menuHasChanged: any = false;

  constructor(private router: Router,
    private http: HttpClient) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(event => {
      });
  }

  getMenuler(): Observable<MenuInfo[]> {
    return this.http.get<MenuInfo[]>(environment.API_MENU_URL);
  }

}
